<div class="Portinfo">

    <div class="Location center">
        <div>
            <span class="nextportlabel" *ngIf="underway"><a class="nextportlabel" [routerLink]="['/portinfo']">Next
                    Port: </a> </span><a class="nextportlabel" [routerLink]="['/portinfo']">{{PortInfo?.gpiCity}},
                {{PortInfo?.gpiState}}</a>
        </div>

    </div>
    <app-dock-address-expander inputdate={{inputdate}}></app-dock-address-expander>
    <div class="tenpxtop"></div>
    <div class="arrivedpt">
        <div class="row arrival" *ngIf="PortInfo?.itibegdate !=PortInfo?.evtbegdate && !inport">
            <div class="col-5 text-end locationlabel">
                Arrival:
            </div>
            <div class="col-3 Arrival center">
                {{PortInfo?.itibegdate | date:'shortTime'}}
            </div>
            <div class="col-4 Arrival text-start">
                {{PortInfo?.itibegdate | date:'MM/dd/yy'}}
            </div>
        </div>
        <div class="row allaboard" *ngIf="PortInfo?.itiEndDate !=PortInfo?.evtEndDate  && !underway">
            <div class="col-5 text-end redtext">
                All Aboard:
            </div>
            <div class="col-3 Arrival center redtext">
                {{boardingDate | date:'shortTime'}}
            </div>
            <div class="col-4 Arrival text-start redtext">
                {{boardingDate | date:'MM/dd/yy' }}
            </div>
        </div>
        <div class="row Departure" *ngIf="PortInfo?.itiEndDate !=PortInfo?.evtEndDate  && !underway">
            <div class="col-5 text-end locationlabel">
                Departure:
            </div>
            <div class="col-3 Arrival center">
                {{PortInfo?.itiEndDate | date:'shortTime'}}
            </div>
            <div class="col-4 Arrival text-start">
                {{PortInfo?.itiEndDate | date:'MM/dd/yy'}}
            </div>
        </div>
        <div class="row Departure" *ngIf="PortInfo?.itiEndDate ==PortInfo?.evtEndDate  && !underway">
            <div class="col-5 text-end locationlabel">
                Disembark:
            </div>
            <div class="col-3 Arrival center">
                8:00 AM
            </div>
            <div class="col-4 Arrival text-start">
                {{PortInfo?.itiEndDate | date:'MM/dd/yy'}}
            </div>
        </div>

    </div>




</div>